import { getAllowedMenus } from '@/store/allowed-menus';

export default function checkPower(id, resolve, reject) {
  const obj = Object.values(getAllowedMenus());
  if (obj.length > 0 && obj.some(({ menuId }) => Number(menuId) === id)) {
    resolve();
  } else {
    reject();
  }
}

function checkPowerCreateActivity(userInfo, resolve, reject) {
  if (!userInfo?.permissions?.createActivity) return reject();

  return resolve();
}

function checkErpCreateActivity(userInfo, resolve, reject) {
  // erp,passport   passport就是外网
  if (userInfo?.loginType === 'erp') return resolve();

  return reject();
}

export { checkPowerCreateActivity, checkErpCreateActivity };
